import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useAddStaticPartReplacement = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.addStaticPartReplacement,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useAddStaticPartReplacement')
        .extras({errorDetails})
        .error('Error occurred while adding a new replacement for static part')

      spawnErrorToast(t('error.addStaticPartReplacement'))
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['staticPartReplacement']})
      spawnSuccessToast(t('success.addStaticPartReplacement'))
    }
  })
}
